"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.bpfrpt_proptype_ThemeType = exports["default"] = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var Theme = {
  '$background-color': '#FFFFFF',
  '$background-alt-color': '#F9F9F9',
  '$link-color': '#368EF8',
  '$inactive-link-color': 'rgba(54,142,248,0.4)',
  '$shadow-color': 'rgba(0,0,0,0.14)',
  '$panel-border-color': '#F0F0F0',
  '$panel-background-color': '#F0F0F0',
  // Text
  '$text-color': '#212322',
  '$heading-color': '#3F4444',
  '$placeholder-color': '#B2B4B4',
  '$error-text-color': '#FD7280',
  '$warning-text-color': '#DBBF0A',
  // Table
  '$table-border-color': '#DDDDDD',
  '$table-footer-text-color': '#3C3C3C',
  '$table-heading-color': '#F5F5F5',
  '$table-footing-color': '#F5F5F5',
  // Input
  '$input-background': '#F9F9F9',
  '$input-background-focus': '#F5F5F5',
  '$input-background-light': '#FFFFFF',
  '$input-background-error': '#FFF1F2',
  '$input-background-warning': '#FFFCE7',
  // Button backgrounds
  '$button-color': '#F9F9F9',
  '$button-color-active': '#F5F5F5',
  '$button-primary-color': '#2DD79A',
  '$button-primary-color-active': '#27E29F',
  '$button-secondary-color': '#B2B4B4',
  '$button-secondary-color-active': '#AAAAAA',
  '$button-negative-color': '#FD7280',
  '$button-negative-color-active': '#F76D7B',
  // Indicator

  /**
   * TO-DO: would be great if these were not specific for this control only but were references to some standard theme colors instead
   */
  '$indicator-green': '#2DD79A',
  '$indicator-grey': '#DDDDDD',
  '$indicator-white': '#FFFFFF',
  // Menu
  '$menu-border-color': '#DDDDDD',
  '$menu-highlight-background-color': '#F5F5F5',
  '$menu-active-background-color': '#EAF3FF',
  // Popover
  '$popover-background': '#212322',
  '$popover-text-color': '#FFFFFF',
  // Fonts
  '$font-default': 'Roboto',
  '$font-monospace': 'Andale Mono',
  '$font-heading': 'Quicksand',
  // InfoBox
  '$infobox-background': '#fffce2',
  // Overlay
  '$overlay-background': '#fff',
  // Z-index master list
  // -------------------------
  // Used for a bird's eye view of components dependent on the z-axis
  '$z-index-dropdown': 1060,
  '$z-index-overlay': 1050
};
var bpfrpt_proptype_ThemeType = _propTypes["default"].any;
exports.bpfrpt_proptype_ThemeType = bpfrpt_proptype_ThemeType;
var _default = Theme;
exports["default"] = _default;
//# sourceMappingURL=colours.js.map